import { registerModule, runWhenPlatformInitialized } from './ltjsEnvironment';
import CommonsPackage from './CommonsPackage';
import CommonsUIPackage from './CommonsUIPackage';
import { loadApplicationTheme } from './util/ThemeLoader';
//Kick off loading ltjs for non-OpenUI apps and setup runtime.
import './ltjsRuntime';
// TODO
// // Needed for ltjsUtil
// import "./resources/localization/LanguageTag";
// import "./resources/ResourceManager";
// // Needed for ThemeLoader
// import "./styles/Style";
registerModule('commons', [CommonsPackage, CommonsUIPackage]);
// Apply application theme before any visuals have been created to
// prevent flash of cpp's hardcoded Raven theme
runWhenPlatformInitialized(function (platformInitCallback) {
    loadApplicationTheme(platformInitCallback);
}, true);
